import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '../services/api';

export const useFinancialStats = (dateRange?: { start_date?: string; end_date?: string }) => {
  return useQuery({
    queryKey: ['financial-stats', dateRange],
    queryFn: () => analyticsApi.getFinancialStats(dateRange),
  });
};